import {Component, HostBinding, Input} from '@angular/core';

@Component({
  selector: 'app-x-placeholder-flexible-loader',
  standalone: true,
  imports: [],
  templateUrl: './x-placeholder-flexible-loader.component.html',
  styleUrl: './x-placeholder-flexible-loader.component.less'
})
export class XPlaceholderFlexibleLoaderComponent {
  @HostBinding('style.flex-grow') @Input() grow: number = 1;
}
